import React, {useCallback} from "react";
import {useTranslation} from "react-i18next";

export const EventContent = ({event, showTitle, timeText, calendarRef, syncMenusWithCalendar}) => {
    const {t} = useTranslation();

    const handleEventRemoveClick = useCallback(
        (e, eventApi) => {
            e.preventDefault();
            e.stopPropagation();
            eventApi.remove();
            const api = calendarRef.current?.getApi();
            if (api) syncMenusWithCalendar(api);
        },
        [syncMenusWithCalendar]
    );

    return (
        <div className={'fc-event-inner'}>
            <div
                className={'fc-event-accent'}
                style={{backgroundColor: event.extendedProps?.color}}
            />
            <div className={'fc-event-content'}>
                <span className={'fc-event-time'}>{timeText}</span>
                {showTitle && <span className={'fc-event-title'}>{event.title}</span>}
            </div>

            <button className={'fc-event-remove'}
                    onClick={(e) => handleEventRemoveClick(e, event)}
                    aria-label={t('remove')}
                    type={'button'}>
                ×
            </button>
        </div>
    );
}